import { shallowEqual, useSelector } from "react-redux"

import { ClientStore, DocumentsStore } from "types/store"

export interface CheckupDocumentPayload {
  relative_id: number | null
  vitals: Record<string, unknown>
}

// A check-up document belongs to the patient it was generated for and to the
// vitals it contains: while both are unchanged, the document can be reused.
export const getCheckupVitalsKey = ({
  relative_id,
  vitals,
}: CheckupDocumentPayload): string => JSON.stringify({ relative_id, vitals })

// True when the check-up document currently in the store matches this payload
export const useHasCheckupDocument = (
  payload: CheckupDocumentPayload,
): boolean => {
  const { documentUrl, checkupVitalsKey } = useSelector(
    ({
      client,
      documents,
    }: {
      client: ClientStore
      documents: DocumentsStore
    }) => ({
      documentUrl: client.documentUrl,
      checkupVitalsKey: documents.checkupVitalsKey,
    }),
    shallowEqual,
  )
  return !!documentUrl && checkupVitalsKey === getCheckupVitalsKey(payload)
}
